import { render, staticRenderFns } from "./PuntoVenta.vue?vue&type=template&id=2d6a1a36&scoped=true&"
import script from "./PuntoVenta.vue?vue&type=script&lang=js&"
export * from "./PuntoVenta.vue?vue&type=script&lang=js&"
import style0 from "./PuntoVenta.vue?vue&type=style&index=0&id=2d6a1a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a1a36",
  null
  
)

export default component.exports